<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="机构" prop="institutionCode">
                <el-select
                    v-model="addForm.institutionCode"
                    style="width:100%"
                    placeholder="请选择机构">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="残疾人" required prop="elderlyName">
                <el-input v-model="addForm.elderlyName" placeholder="选择残疾人" disabled style="">
                  <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
                  <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24" class="item">
              <el-form-item label="备注" >
                <el-input v-model="addForm.remarks" type="textarea" :rows="2" placeholder="输入备注" style=""></el-input>
              </el-form-item>
            </el-col>
          </el-row>


        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">提交</el-button>
      </div>
    </div>

    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>

  </div>
</template>

<script>

import { timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Elderly from "@/views/Elderly/Comm/ElderlyInsCheckIn3";


export default {
  name: 'Add',
  props:['arr_ins'],
  data() {
    return {

      loading: false,

      showModalGetElderly:false,


      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        institutionCode:'',

        elderlyCode:'',
        elderlyName:'',
        remarks:'',
      },


      rules:{
        elderlyName:[
          { required: true, message: '请选择老人', trigger: 'blur' },
          { required: true, message: '请选择老人', trigger: 'change' },
        ],
        institutionCode:[
          { required: true, message: '请选择机构', trigger: 'blur' },
        ],
      },

      type:'',


    }
  },
  components:{
    Elderly
  },
  methods: {
    init(type){

      this.type = type;

      this.$refs.addForm.resetFields();
      this.addForm.remarks = '';

    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init(this.type,this.addForm.institutionCode);
    },
    setElderly(row){
      this.addForm.elderlyCode = row.elderlyCode;
      this.addForm.elderlyName = row.name;
    },
    clearElderly(){
      this.addForm.elderlyCode = '';
      this.addForm.elderlyName = '';
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CheckWardRecord/GovAddIns",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {

              this.$emit("closeAdd");
              this.$emit("getList");

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


  }
}


</script>
<style lang="scss" scoped>

</style>
